import { render, staticRenderFns } from "./staffpositions.vue?vue&type=template&id=7124d768&"
import script from "./staffpositions.vue?vue&type=script&lang=js&"
export * from "./staffpositions.vue?vue&type=script&lang=js&"
import style0 from "./staffpositions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports